
const PeopleSvg = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4535 5.52C12.4038 5.5129 12.354 5.5129 12.3043 5.52C11.2032 5.48448 10.3293 4.58225 10.3293 3.474C10.3293 2.34444 11.2458 1.4209 12.3824 1.4209C13.512 1.4209 14.4356 2.33734 14.4356 3.474C14.4284 4.58225 13.5546 5.48448 12.4535 5.52Z"
        fill="#59B29F"
      />
      <path
        d="M14.7696 10.4431C13.9739 10.9759 12.8586 11.1748 11.8285 11.0398C12.0984 10.4573 12.2405 9.8108 12.2476 9.1288C12.2476 8.41838 12.0913 7.74349 11.793 7.15384C12.8444 7.01176 13.9597 7.21067 14.7625 7.74349C15.885 8.48232 15.885 9.69713 14.7696 10.4431Z"
        fill="#59B29F"
      />
      <path
        d="M4.57506 5.52C4.62479 5.5129 4.67451 5.5129 4.72424 5.52C5.82539 5.48448 6.6992 4.58225 6.6992 3.474C6.6992 2.33734 5.78276 1.4209 4.6461 1.4209C3.51654 1.4209 2.6001 2.33734 2.6001 3.474C2.6001 4.58225 3.47391 5.48448 4.57506 5.52Z"
        fill="#59B29F"
      />
      <path
        d="M4.65318 9.12893C4.65318 9.81804 4.80237 10.4716 5.07233 11.0613C4.07064 11.1678 3.02633 10.9547 2.25908 10.4503C1.13662 9.70437 1.13662 8.48956 2.25908 7.74362C3.01923 7.23212 4.09196 7.0261 5.10075 7.13977C4.80948 7.73652 4.65318 8.41141 4.65318 9.12893Z"
        fill="#59B29F"
      />
      <path
        d="M8.61016 11.2744C8.55333 11.2673 8.48939 11.2673 8.42545 11.2744C7.11829 11.2317 6.07397 10.159 6.07397 8.83763C6.08108 7.48784 7.16802 6.3938 8.52491 6.3938C9.8747 6.3938 10.9687 7.48784 10.9687 8.83763C10.9616 10.159 9.92443 11.2317 8.61016 11.2744Z"
        fill="#59B29F"
      />
      <path
        d="M6.30137 12.7448C5.22864 13.4623 5.22864 14.6416 6.30137 15.352C7.52329 16.169 9.52666 16.169 10.7486 15.352C11.8213 14.6345 11.8213 13.4552 10.7486 12.7448C9.53377 11.9278 7.53039 11.9278 6.30137 12.7448Z"
        fill="#59B29F"
      />
    </svg>
  );
};

export default PeopleSvg;
